module.exports = __webpack_public_path__ + "img/9788971998069.ad4c15bc.jpg";